import React, { useState } from 'react';

import { Button } from 'react-bootstrap';
import './GridViewItem.scss';
import DeleteModal from '../../../../components/JobProfile/DeleteModal';
interface GridViewItemProps {
    record?: object | null;
    index: number;
    canEdit: boolean;
    columns: any;
    onEdit?: (record: any) => void;
    onDelete?: (record: any) => void;
}

const GridViewItem = ({ record, index, canEdit, onEdit, onDelete, columns }: GridViewItemProps): React.ReactElement => {
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const includedKeys = columns.map(column => column.key);
    const isOdd = index % 2 == 1;
    const containerStyle = `GridViewItem-Bottom-Container ${!isOdd && 'GridViewItem-Bottom-Container-With-Background'}`;

    const handleDelete = () => {
        onDelete && onDelete(record);
        setDeleteConfirm(false);
    };
    return (
        <div className={containerStyle}>
            {record &&
                Object.keys(record)
                    .filter(key => includedKeys.includes(key))
                    .map((item: string, ind: number) => (
                        <div key={ind} className="GridViewItem-List-Header">
                            {record[item]}
                        </div>
                    ))}
            {!canEdit && <div className="GridViewItem-List-Header"></div>}
            {canEdit && (
                <div className="GridViewItem-List-Header">
                    {canEdit && (
                        <div
                            onClick={() => onEdit && onEdit(record)}
                            className={` ${
                                canEdit ? 'GridViewItem-Edit-Container' : 'GridViewItem-Edit-Container-Disable'
                            }`}
                        >
                            <i className="material-icons UsersItem-Icon">edit</i>
                            <span className="UsersItem-Link">Edit</span>
                        </div>
                    )}
                    &nbsp;|&nbsp;
                    {canEdit && onDelete && (
                        <div onClick={() => setDeleteConfirm(true)} className={` ${'GridViewItem-Edit-Container'}`}>
                            <i className="material-icons UsersItem-Icon">delete</i>
                            <span className="UsersItem-Link">Delete</span>
                        </div>
                    )}
                </div>
            )}
            <DeleteModal
                show={deleteConfirm}
                name={'record'}
                onConfirm={handleDelete}
                onCancel={() => setDeleteConfirm(false)}
            />
        </div>
    );
};

export default GridViewItem;

